import { combineReducers } from 'redux'

import allergenReducer from './allergen-reducer'
import allergensReducer from './allergens-reducer'

export default combineReducers({
  allergens: allergensReducer,
  allergen: allergenReducer,
})
